import {
	ALL_TRANSACTION_LIST_START,
	ALL_TRANSACTION_LIST_SUCCESS,
	ALL_TRANSACTION_LIST_ERROR,
	PENDING_TRANSACTION_LIST_START,
	PENDING_TRANSACTION_LIST_SUCCESS,
	PENDING_TRANSACTION_LIST_ERROR,
	COMPLETED_TRANSACTION_LIST_START,
	COMPLETED_TRANSACTION_LIST_SUCCESS,
	COMPLETED_TRANSACTION_LIST_ERROR,
} from "../Constant/TourPartnerTransactionListConstant";

const initialState = {
	loading: false,
	allTransactionListData: null,
	pendingTransactionListData: null,
	completedTransactionListData: null,
};
export default function TourPartnerTransactionListReducer(
	state = { ...initialState },
	action
) {
	switch (action.type) {
		case ALL_TRANSACTION_LIST_START:
			return {
				...state,
				loading: true,
				allTransactionListData: null,
			};
		case ALL_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				allTransactionListData: action.payload,
				loading: false,
			};
		case ALL_TRANSACTION_LIST_ERROR:
			return {
				...state,
				loading: false,
				allTransactionListData: null,
				message: action.error.message,
			};
		case PENDING_TRANSACTION_LIST_START:
			return {
				...state,
				loading: true,
			};
		case PENDING_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				pendingTransactionListData: action.payload,
				loading: false,
			};
		case PENDING_TRANSACTION_LIST_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};
		case COMPLETED_TRANSACTION_LIST_START:
			return {
				...state,
				loading: true,
			};
		case COMPLETED_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				completedTransactionListData: action.payload,
				loading: false,
			};
		case COMPLETED_TRANSACTION_LIST_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};
		default:
			return state;
	}
}
